<ng-container *ngrxLet="activeLanguage$ as activeLanguage">
    <ng-container *ngIf="activeLanguage === 'pl'">
        <p>
            Mając na uwadze treść § 10 ust. 1 i 2 regulaminu Konkursu do naboru podmiotów do współpracy przy wdrożeniu usługi w ramach
            projektu "Rozbudowa i wyposażenie centrów kompetencji (specjalistyczne ośrodki szkoleniowe, ośrodki wsparcia wdrożeń, centra
            monitorowania) oraz infrastruktura do zarządzania ruchem pojazdów bezzałogowych jako ekosystem innowacji" (dalej:
            "<strong>Regulamin</strong>"), postanawia się co następuje:
        </p>
        <ol class="outer-list">
            <li>
                Regulamin ulega zmianie w ten sposób, że § 9 otrzymuje brzmienie:
                <em>
                    <ol class="outer-list">
                        <p class="sub-title">§ 9. Wybór Uczestników</p>
                        <li>
                            Na podstawie przeprowadzonej analizy i oceny wszystkich Wniosków złożonych w ramach Etapu II KOW dokona wyboru
                            nie więcej niż 4 (czterech) Uczestników (Laureatów) do utworzenia CK i wdrożenia Usługi według poniższych zasad:
                            <ol class="inner-list">
                                <li>
                                    w każdym z czterech zdefiniowanych poniżej obszarów wyłoniony zostanie 1 (jeden) Uczestnik (Laureat),
                                    którego Wniosek otrzyma największą liczbę punktów przyznanych zgodnie z postanowieniami § 8:
                                    <p>a) Obszar 1 – województwa: zachodniopomorskie, pomorskie, warmińsko-mazurskie i podlaskie;</p>

                                    <p>b) Obszar 2 – województwa: wielkopolskie, kujawsko-pomorskie, mazowiecki i łódzkie;</p>

                                    <p>c) Obszar 3 – województwa: lubuskie, dolnośląskie, opolskie i śląskie;</p>

                                    <p>d) Obszar 4 – województwa: świętokrzyskie, małopolskie, podkarpackie i lubelskie.</p>
                                </li>
                                <li>
                                    jeżeli z jakichkolwiek przyczyn nie będzie możliwe dokonanie wyboru Wniosku(-ów) zgodnie z parytetem
                                    wskazanym w pkt. 1 powyżej (np. w sytuacji, w której nie wpłynie żaden Wniosek obejmujący dany Obszar,
                                    bądź wszystkie Wnioski obejmujące dany Obszar zostaną odrzucone), PAŻP – w miejsce wyboru Wniosku
                                    zgodnie z pkt. 1 powyżej – dokona wyboru Wniosku(-ów), który(-e) otrzyma(-ją) największą liczbę punktów
                                    przyznanych zgodnie z postanowieniami § 8.
                                </li>
                            </ol>
                        </li>
                        <li>
                            Wyniki Konkursu i Lista Laureatów, w tym lista Wniosków, które spełniły kryteria i brały udział w Konkursie,
                            zostanie opublikowana na stronie internetowej Krajowego Systemu Informacji Dronowej (<a
                                href="https://drony.gov.pl"
                                target="_blank"
                                rel="noopener norefer"
                                >https://drony.gov.pl</a
                            >), nie później niż 7 dni po rozstrzygnięciu Konkursu.
                        </li>
                        <li>
                            Laureaci, którzy zostali wybrani do współpracy przy utworzeniu CK i wdrożeniu Usługi, otrzymają informacje o
                            pozytywnym wyniku oceny wraz z prośbą o przygotowania dokumentów niezbędnych do podpisania Umowy o współpracy.
                        </li>
                        <li>
                            Umowa o współpracy powinna zostać zawarta w ciągu 14 dni od momentu poinformowania Uczestnika – Laureata o
                            wyborze do współpracy przy utworzeniu CK i wdrożeniu Usługi. W szczególnych przypadkach, na uzasadniony wniosek
                            Uczestnika, termin ten może zostać wydłużony maksymalnie o dwa tygodnie.
                        </li>
                        <li>
                            Jeżeli Umowa o współpracy nie zostanie zawarta w terminie, o którym mowa w ust. 4, z przyczyn nie leżących po
                            stronie PAŻP, wybrana Lokalizacja zostaje odrzucona a Uczestnik traci prawo udziału w Konkursie.
                        </li>
                        <li>
                            W sytuacji, o której mowa w ust. 5, PAŻP będzie uprawniony do zawarcia Umowy o współpracy z Uczestnikiem,
                            którego Wniosek otrzymał kolejną najwyższą ocenę.
                        </li>
                    </ol>
                </em>
            </li>
            <li>
                Ustala się tekst jednolity Regulaminu oraz zarządza jego niezwłoczną publikację pod adresem:
                <a href="https://drony.gov.pl" target="_blank" rel="noopener norefer">https://drony.gov.pl</a>.
            </li>
            <li>
                Zmiany Regulaminu, o których mowa w pkt. 1 powyżej uzasadnione są potrzebą optymalizacji zakresu usług mających stanowić
                efekt przeprowadzonego Konkursu pod kątem możliwości i aktualnego stanu rozwoju rynku dronowego w Polsce. W toku I Etapu
                Konkursu zidentyfikowano potrzebę dostosowania liczby obszarów konkursowych z pięciu do czterech, co lepiej odpowiada
                aktualnej sytuacji i lokalizacji składanych wniosków. Celem wprowadzanych zmian jest optymalne dopasowanie produktu
                konkursowego – Centrów Kompetencji – do aktualnych precyzyjnych potrzeb i wymagań rynku, jego potencjału oraz kierunków
                rozwoju sektora w najbliższych latach. Zmiany te mają również na celu celowe, oparte ściśle o najnowsze dane, racjonalne i
                efektywne wydatkowanie funduszy europejskich.
            </li>
            <li>Zmiana Regulaminu wchodzi w życie z dniem 6 sierpnia 2025 r.</li>
        </ol>
    </ng-container>
    <ng-container *ngIf="activeLanguage === 'en'">
        <p>
            Taking into account the content of § 10 sections 1 and 2 of the Rules for the recruitment of entities to cooperate in the
            implementation of the service under the project "Expansion and equipment of competence centers (specialized training centers,
            implementation support centers, monitoring centers) and infrastructure for unmanned vehicle traffic management as an innovation
            ecosystem" (hereinafter: "<strong>Rules</strong>"), it is decided as follows:
        </p>
        <ol class="outer-list">
            <li>
                The Rules are amended so that § 9 shall read as follows:
                <em>
                    <ol class="outer-list">
                        <p class="sub-title">§ 9. Selection of Participants</p>
                        <li>
                            Based on the analysis and evaluation of all Applications submitted under Stage II, the Competition Committee
                            will select no more than 4 (four) Participants (Winners) to establish the Competence Centers and implement the
                            Service according to the following rules:
                            <ol class="inner-list">
                                <li>
                                    In each of the four areas defined below, 1 (one) Participant (Winner) will be selected whose Application
                                    receives the highest number of points awarded in accordance with the provisions of § 8:
                                    <p>a) Area 1 – voivodeships: zachodniopomorskie, pomorskie, warmińsko-mazurskie, and podlaskie;</p>
                                    <p>b) Area 2 – voivodeships: wielkopolskie, kujawsko-pomorskie, mazowieckie, and łódzkie;</p>
                                    <p>c) Area 3 – voivodeships: lubuskie, dolnośląskie, opolskie, and śląskie;</p>
                                    <p>d) Area 4 – voivodeships: świętokrzyskie, małopolskie, podkarpackie, and lubelskie.</p>
                                </li>
                                <li>
                                    If, for any reason, it is not possible to select an Application(s) in accordance with the parity
                                    indicated in point 1 above (e.g., if no Application covering a given Area is submitted, or all
                                    Applications covering a given Area are rejected), PANSA – instead of selecting an Application in
                                    accordance with point 1 above – will select the Application(s) that receive(s) the highest number of
                                    points awarded in accordance with the provisions of § 8.
                                </li>
                            </ol>
                        </li>
                        <li>
                            The results of the Competition and the List of Winners, including the list of Applications that met the criteria
                            and participated in the Competition, will be published on the website of the National Drone Information System
                            (<a href="https://drony.gov.pl" target="_blank" rel="noopener norefer">https://drony.gov.pl</a>), no later than
                            7 days after the conclusion of the Competition.
                        </li>
                        <li>
                            Winners selected to cooperate in the establishment of the Competence Center and implementation of the Service
                            will receive information about the positive evaluation result along with a request to prepare the documents
                            necessary to sign the Cooperation Agreement.
                        </li>
                        <li>
                            The Cooperation Agreement should be concluded within 14 days from the moment the Participant – Winner is
                            informed about the selection for cooperation in the establishment of the Competence Center and implementation of
                            the Service. In special cases, upon a justified request of the Participant, this period may be extended by a
                            maximum of two weeks.
                        </li>
                        <li>
                            If the Cooperation Agreement is not concluded within the period referred to in section 4, for reasons not
                            attributable to PANSA, the selected Location is rejected and the Participant loses the right to participate in
                            the Competition.
                        </li>
                        <li>
                            In the situation referred to in section 5, PANSA will be entitled to conclude a Cooperation Agreement with the
                            Participant whose Application received the next highest score.
                        </li>
                    </ol>
                </em>
            </li>
            <li>
                The consolidated text of the Rules is established and its immediate publication at:
                <a href="https://drony.gov.pl" target="_blank" rel="noopener norefer">https://drony.gov.pl</a> is ordered.
            </li>
            <li>
                The amendments to the Rules referred to in item 1 above are justified by the need to optimize the scope of services to be
                the result of the Competition in terms of the possibilities and current state of development of the drone market in Poland.
                During the first stage of the Competition, the need to adjust the number of competition areas from five to four was
                identified, which better corresponds to the current situation and the locations of submitted applications. The purpose of
                the introduced changes is to optimally adapt the competition product – Competence Centers – to the current precise needs and
                requirements of the market, its potential, and the directions of sector development in the coming years. These changes are
                also intended to ensure purposeful, strictly data-driven, rational, and effective spending of European funds.
            </li>
            <li>The amendment to the Rules enters into force on 6 August 2025.</li>
        </ol>
    </ng-container>
</ng-container>
